import { BaseTool } from '../BaseTool';

/**
 * Relinquish All Mine — releases workset ownership held by the local user
 * back to the rest of the team.
 */
export class RelinquishAllMineTool extends BaseTool {
    id = 'COLLAB_RELINQUISH';
    name = 'Relinquish All Mine';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('relinquish');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
